import { trigger, transition, style, animate } from '@angular/animations';

export const ONE_ID_UI_ANIMATIONS = [
    trigger('fadeInOutAnimation', [
        transition(':enter', [
            style({
                opacity: 0, height: 0,
            }),
            animate('150ms 250ms ease', style({
                opacity: 1, height: '*',
            })),
        ]),
        transition(':leave', [
            style({
                opacity: 1, height: '*',
            }),
            animate('150ms ease', style({
                opacity: 0, height: 0,
            })),
        ]),
    ]),
    trigger(
        'emailErrorMessageAnimation',
        [
            transition(
                ':enter',
                [
                    style({ opacity: 0, height: 0, margin: 0 }),
                    animate(
                        '200ms ease',
                        style({ opacity: 1, height: '*', margin: '9px 5px 5px 0' })
                    ),
                ]
            ),
            transition(
                ':leave',
                [
                    style({ opacity: 1, height: '*', margin: '9px 5px 5px 0' }),
                    animate(
                        '200ms ease',
                        style({ opacity: 0, height: 0, margin: 0 })
                    ),
                ]
            ),
        ]
    ),
];
